import React from "react";
import cn from "./helpers/cn";

interface ListItemIconProps extends React.HTMLAttributes<HTMLDivElement> {
  component?: React.ElementType;
  children?: React.ReactNode;
}

const ListItemIcon = React.forwardRef<HTMLDivElement, ListItemIconProps>((props, ref) => {
  const { className, component: Component = "div", children, ...other } = props;

  return (
    <Component
      ref={ref}
      className={cn(
        // MUI v4: min-width 56px, flex shrink 0, cor cinza (text.secondary).
        "min-w-[56px] shrink-0 inline-flex items-center text-slate-500",
        className
      )}
      {...other}
    >
      {children}
    </Component>
  );
});

ListItemIcon.displayName = "ListItemIcon";

export default ListItemIcon;
